import { MouseEventHandler, ReactElement, Fragment } from 'react';
import {
  DevHubBox,
  DevHubButton,
  DevHubCircularProgress,
  DevHubDynamicIcon,
  DevHubGrid,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';
import { ApolloError } from '@apollo/client';

type Props = {
  submitted: boolean;
  loading: boolean;
  success: boolean;
  error: ApolloError | undefined | boolean;
  handleClose: MouseEventHandler<HTMLButtonElement>;
  errorMessage: string | ReactElement;
};

/**
 * Component to handle submitted response messages from fusion for role mutations
 * @param props props of the component
 * @param props.submitted boolean of form has been submitted or not
 * @param props.loading boolean of loading state from apollo
 * @param props.error error returned by apollo client
 * @param props.success form has been successfully submitted
 * @param props.handleClose event handler to handle closing the modal
 * @param props.errorMessage message to display in event of on errror
 */
export function Submitted(props: Props) {
  const submittedBox = () => {
    if (props.submitted && props.loading) {
      return <DevHubCircularProgress size={68} />;
    } else if (props.submitted && props.success) {
      return (
        <Fragment>
          <DevHubDynamicIcon
            iconName="CheckCircleOutline"
            color="success"
            fontSize="xl"
          />
          <DevHubTypography>Success!</DevHubTypography>
        </Fragment>
      );
    } else if (props.submitted && props.error) {
      return (
        <Fragment>
          <DevHubDynamicIcon
            iconName="HighlightOff"
            color="error"
            fontSize="xl"
          />
          <DevHubTypography>{props.errorMessage}</DevHubTypography>
        </Fragment>
      );
    }
    return <></>;
  };

  return (
    <>
      <DevHubGrid container padding="large" justifyContent="center">
        <DevHubGrid item>
          <DevHubBox display="flex" flexDirection="column" alignItems="center">
            {submittedBox()}
          </DevHubBox>
        </DevHubGrid>
      </DevHubGrid>
      <DevHubBox display="flex" justifyContent="center" alignItems="center">
        <DevHubButton
          variant="contained"
          color="primary"
          onClick={props.handleClose}
        >
          Close
        </DevHubButton>
      </DevHubBox>
    </>
  );
}
